// extracted by mini-css-extract-plugin
export default {"primary":"style_primary__lR2xi"};